import { curCoreClient } from './CoreClient';
import _ from "lodash";
import {ApiKey} from "@/types/core";
import {HttpResponse} from "@/types/http";

export class ApiKeyService {

  public async getApiKeys(query: GetApiKeysQuery): Promise<HttpResponse & GetApiKeysReply> {

    const allApiKeysReply = await this.getAllApiKeys();

    if(allApiKeysReply.errorMsg)
      return Promise.resolve({errorMsg:allApiKeysReply.errorMsg, httpCode:allApiKeysReply.httpCode});

    let allApiKeys = allApiKeysReply.apiKeyList as ApiKey[];

    // we sort by the specified key (deviceId or lastOnline)
    this.sort(allApiKeys, query.orderBy, query.ascDesc);

    if (query.filter) {

      allApiKeys = allApiKeys.filter((key) => {

        if (key.apiKey.includes(query.filter.toLowerCase()))
          return true;

        if (key.description && key.description.includes(query.filter.toLowerCase()))
          return true;

        if (key.groupIdList &&
          key.groupIdList.some((groupId) => groupId.toLowerCase().includes(query.filter.toLowerCase())))
          return true;

        return false;
      });
    }

    return Promise.resolve({apiKeyPageList:this.paginateApiKeyList(allApiKeys, query.pageSize)});

  }

  private sort(list: any[], key: string, ascDesc: 'asc'|'desc') {

    // we sort asc first
    list.sort((a, b) => {

      if (a[key] < b[key] || a[key] === undefined) {
        return ascDesc === 'asc' ? -1 : 1;
      } else if (a[key] > b[key] || b[key] === undefined) {
        return ascDesc === 'asc' ? +1 : -1;
      } else
        return 0;
    });

  }

  private async getAllApiKeys(): Promise<{errorMsg?:string, httpCode?:number, apiKeyList?:ApiKey[]}>{

    let retList: ApiKey[] = [];

    let skip = 0;
    while (true) {

      const resp = await curCoreClient.getApiKeys({skip, limit: 1000});

      if (resp.errorMsg)
        return Promise.resolve({errorMsg:`Unable to load all users: ${resp.errorMsg}`, httpCode: resp.httpCode});

      if (!resp.apiKeyList || resp.apiKeyList.length === 0)
        break;

      retList = retList.concat(resp.apiKeyList);

      if (resp.apiKeyList.length < 1000)
        break;

      // we increment skip
      skip += resp.apiKeyList.length;
    }

    return Promise.resolve({apiKeyList: retList});
  }

  private paginateApiKeyList(apiKeyList: ApiKey[], pageSize: number): ApiKeyPage[] {

    const chunkedList = _.chunk(apiKeyList, pageSize);

    return chunkedList.map((chunkedListItem:any, index:number) => ({
      pageNum: index,
      apiKeyList: chunkedListItem,
    }));
  }

}

export interface GetApiKeysQuery {
  orderBy: 'apiKey';
  ascDesc: 'asc';
  pageSize: number;
  filter: string;
}

export interface GetApiKeysReply {
  apiKeyPageList?: ApiKeyPage[];
}

export interface ApiKeyPage {
  pageNum: number;
  apiKeyList: ApiKey[];
}

export const curApiKeyService = new ApiKeyService();